import Breadcrumbs from 'my-components/Breadcrumbs';
import WizeLogo from 'my-components/WizeLogo';

import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import logoSrc from 'images/logo/icon.svg';

const rootCss = ({ breakpoints, palette, spacing }) => ({
  position: 'relative',
  backgroundColor: palette.background.paper,
  padding: spacing(8, 8, 3),
  '.CPCH-progress': {
    position: 'absolute',
    height: 12,
    top: 0,
    left: 0,
    right: 0,
  },
  '.CPCH-header': {
    display: 'flex',
    alignItems: 'center',

    '& > * + *': { marginLeft: spacing(2) },
  },
  '.CPCH-img': { height: 44 },
  '.CPCH-spacer': { flex: 1 },
  '.CPCH-closeButton': {
    width: 48,
    position: 'absolute',
    top: 12,
    right: 8,
  },
  '.CPCH-breadcrumbs': { marginTop: spacing(1) },
  [breakpoints.only('xs')]: {
    padding: spacing(3, 2),
  },
});

export default function CoursePurchaseCheckoutHeader({ activeStep, breadcrumbs, loading, onChangeStep, onClose }) {
  return (
    <div css={rootCss}>
      <LinearProgress className="CPCH-progress" {...(loading ? {} : { value: 100, variant: 'determinate' })} />
      <div className="CPCH-header">
        {/* <img alt="wize logo" className="CPCH-img" src={logoSrc} /> */}
        <WizeLogo className="CPCH-img" />
        <Typography variant="h5">Checkout</Typography>
        <div className="CPCH-spacer" />
        <IconButton className="CPCH-closeButton" disabled={loading} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </div>
      <Breadcrumbs
        active={activeStep}
        className="CPCH-breadcrumbs"
        disabled={activeStep === breadcrumbs.length - 1 || loading}
        items={breadcrumbs}
        onChange={onChangeStep}
      />
    </div>
  );
}
